import styled from "styled-components";

export const PollutionInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
`;
export const LabelDiv = styled.div`
  border-bottom: ${(props) => (props?.border ? props.border : "1px")} solid
    #ededed;
  color: #004c7f;
  width: 70%;
`;

export const ValueDiv = styled.div`
  border-bottom: ${(props) => (props?.border ? props.border : "1px")} solid
    #ededed;
  text-align: center;
  color: #474747;
  width: 15%;
}
`;

export const AlertDiv = styled.div`
  border: solid 1px #e83f1e;
  margin-bottom: 26px;
  padding: 8px;
  color: #e83f1e;
`;
export const PaddingDiv = styled.div`
  padding: ${(props) => props.padding};
`;

export const EditDiv = styled.div`
  display: flex;
  justify-content: end;
  margin: 10px 10px -17px 0;
`;

export const BoxDiv = styled.div`
  margin: 0;
  column-count: 2;
  -moz-column-fill: auto;
  -moz-column-count: 2;
  height: auto;
`;

export const PollutionSubDiv = styled.div`
  display: flex;
  line-height: 1.8;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
`;

export const TextInput = styled.input`
  box-sizing: border-box;
  background: #ffffff;
  width: 100%;
  height: 22px;
  border: 1px solid #767676;
  border-radius: 5px;
  text-align: start;
  padding-top: 3px;
  ${(props) => props.inputStyles};
`;

export const RequiredMessage = styled.p`
  width: 100%;
  color: red;
  font-size: 0.875rem;
  font-family: Lato;
  line-height: 1;
  margin: 0;
  padding: 0;
  white-space: nowrap;
  position: relative;
  ${(props) => props.errorStyles};
`;

export const StrictLimitInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;
